import { rankingData } from '@/mocks/homeData';

const changeConfig: Record<string, { icon: string; color: string; label: string }> = {
  new: { icon: 'ri-sparkling-line', color: 'text-primary-500', label: '新' },
  up1: { icon: 'ri-arrow-up-s-line', color: 'text-accent-500', label: '↑1' },
  up2: { icon: 'ri-arrow-up-s-line', color: 'text-accent-500', label: '↑2' },
  up3: { icon: 'ri-arrow-up-s-line', color: 'text-accent-500', label: '↑3' },
  up5: { icon: 'ri-arrow-up-s-line', color: 'text-accent-500', label: '↑5' },
  down1: { icon: 'ri-arrow-down-s-line', color: 'text-secondary-500', label: '↓1' },
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-1">
              热门榜单
            </h2>
            <p className="text-sm text-foreground-500">实时更新 · 热度排序</p>
          </div>
        </div>
        <div className="bg-background-100 rounded-2xl border border-background-200/70 overflow-hidden">
          {rankingData.map((item, idx) => {
            const change = changeConfig[item.change];
            const isTop3 = item.rank <= 3;
            return (
              <a
                key={item.rank}
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className={`flex items-center gap-3 md:gap-4 px-4 md:px-6 py-3 md:py-4 hover:bg-background-50 transition-colors cursor-pointer ${
                  idx < rankingData.length - 1 ? 'border-b border-background-200/70' : ''
                }`}
              >
                <span
                  className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold flex-shrink-0 ${
                    isTop3
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-200 text-foreground-600'
                  }`}
                >
                  {item.rank}
                </span>
                <div className="flex-1 min-w-0">
                  <span className="text-sm font-medium text-foreground-800">{item.title}</span>
                </div>
                <span className="text-xs text-foreground-400 flex items-center gap-1 whitespace-nowrap">
                  <i className="ri-fire-line text-primary-500 text-xs"></i>
                  {item.heat}
                </span>
                {change && (
                  <span className={`text-xs font-semibold ${change.color} flex items-center gap-0.5 whitespace-nowrap`}>
                    <i className={change.icon}></i>
                    {change.label}
                  </span>
                )}
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}